export const fr = {
    titreOnglet: "Transactions | Desjardins"
};
